import { Article } from 'src/app/services/yeti-protocol/article';

class TriggerPointBase {
  name: string;
  description: string
  version: number
  creationTime: string
  createdBy: string
}

export class TriggerPoint extends TriggerPointBase {
  connectors: Array<string>
}

export class TriggerPointsListResponse {
  triggerPoints: Array<TriggerPoint>;
  success: boolean;
  error: any;
}

export class ConnectorInfo {
  name: string;
  description: string;
  parameters: Map<string, string>;
  configOverrides?: Map<string, any>;
  configDefaults?: Map<string, any>;
}

export class TriggerPointInfo extends TriggerPointBase {
  connectors: Array<ConnectorInfo>;
}

export class TriggerPointResponse {
  triggerPoint: TriggerPointInfo;
  success: boolean;
  error: any;
}

export enum RecommendationItemType {
  article = 'article',
  video = 'video-article'
}

export interface RecommendationRequestParams {
  [index: string]: any;
}

export class ArticleRecommendation{
  type: string; // RecommendationItemType.article.valueOf();
  id: string;
  title: string;
  score?: number;
  article?: Article;
}

export interface RecommendationsContext {
  context: string;
  userId: string;
}
export type RecommendationItem = ArticleRecommendation;

export interface ConnectorPredictions {
  connector: string;
  recommendations: Array<RecommendationItem>;
}

export class TriggerPointRecommendations {
  triggerPoint: string;
  predictions: Array<ConnectorPredictions>;
}

export class TriggerPointRecommendationsResponse extends TriggerPointRecommendations {
  success: boolean;
  error: any;
}

export class TriggerPointRecommendationsData extends TriggerPointRecommendations {
  triggerPointDescription: string;
}
